import { render, staticRenderFns } from "./PreOrdersChildrens.vue?vue&type=template&id=623565fb"
import script from "./PreOrdersChildrens.vue?vue&type=script&lang=js"
export * from "./PreOrdersChildrens.vue?vue&type=script&lang=js"
import style0 from "./PreOrdersChildrens.vue?vue&type=style&index=0&id=623565fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports